/* eslint no-shadow: 0 */
/* eslint prefer-const: 0 */
import React, { Children, cloneElement } from "react";
import { compose, withState, withHandlers } from "recompose";
import { chain } from "lodash";
import classNames from "classnames";

export class NoKeyDefinedError {
  constructor(message) {
    this.message = message;
  }
}

const GridContainer = ({
  onSelectAllChanged,
  selectAll,
  selected,
  onSelectChanged,
  className: tmpClassName,
  ...props
}) => {
  const grid = Children.only(props.children);

  const children = Children.map(grid.props.children, (row) => {
    let { children, ...props } = row.props;

    children = Children.map(children, (col) => {
      let { children, ...props } = col.props;

      children = Children.map(children, (card) => {
        let { children, ...props } = card.props;

        children = Children.map(children, (div) => {
          let { select, children, ...props } = div.props;

          if (select) {
            if (!col.key)
              throw new NoKeyDefinedError("key not defined on grid div");
            children = (
              <input
                type="checkbox"
                onChange={(e) => onSelectChanged(e, col.key)}
                checked={selected[col.key] || false}
              />
            );
          }
          return <div.type {...props}>{children}</div.type>;
        });
        return <card.type {...props}>{children}</card.type>;
      });
      return <col.type {...props}>{children}</col.type>;
    });

    return <row.type {...props}>{children}</row.type>;
  });

  const className = classNames("grid-container", tmpClassName);

  return cloneElement(grid, { className }, children);
};

const enhance = compose(
  withState("selectAll", "setSelectAll", false),
  withHandlers({
    onSelectAllChanged:
      ({ setSelectAll, onSelectedChanged, items }) =>
      (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        if (checked) {
          onSelectedChanged(
            chain(items)
              .map((i) => [i.id, true])
              .fromPairs()
              .value()
          );
        } else {
          onSelectedChanged({});
        }
      },
    onSelectChanged:
      ({ onSelectedChanged, selected }) =>
      (e, key) => {
        const checked = e.target.checked;
        const copy = { ...selected, [key]: checked };
        if (!copy[key]) delete copy[key];
        onSelectedChanged(copy);
      },
  })
);

export default enhance(GridContainer);
